import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Typography,
} from "@mui/material";
import { executeMoleculeCreation } from "../../lib/resets";
import { useContext, useState } from "react";
import { GameContext } from "../../provider/GameProvider";
import { calculateExpectedMoleculeValue } from "../../lib/calculator";
import {
  loadObjectFromLocalStorage,
  saveObjectToLocalStorage,
} from "../../save/localSave";

export function MoleculeCreationDialog(props: {
  open: boolean;
  setOpen: (value: React.SetStateAction<boolean>) => void;
}) {
  const { game, setGame, setTimeProgressArray } = useContext(GameContext);
  const expectedMolecules = calculateExpectedMoleculeValue(game);
  const moleculeText = expectedMolecules.notEquals(1)
    ? "Molecules"
    : "Molecule";
  const localHide = loadObjectFromLocalStorage("hideMoleculeCreationDialog");
  const [hideOnNextReset, setHideOnNextReset] = useState(false);

  return (
    <Dialog
      open={props.open && !localHide}
      onClose={() => props.setOpen(false)}
    >
      <DialogTitle style={{ color: "darkorange" }}>
        Molecule Creation
      </DialogTitle>
      <DialogContent>
        <Typography style={{ color: "white", opacity: 0.8 }}>
          You will get {expectedMolecules.toString()} {moleculeText} for
          resetting your producers, Producers Strengthening, Strengthening
          Boost, Automators and Speed-Shop.
        </Typography>
        <FormControlLabel
          style={{ paddingTop: 24, color: "white", opacity: 0.8 }}
          control={
            <Checkbox
              checked={hideOnNextReset}
              onChange={(e) => {
                setHideOnNextReset(e.target.checked);
              }}
              style={{ color: "white", opacity: 0.8 }}
            />
          }
          label={
            <div style={{ color: "white" }}>
              Hide this message on next reset
            </div>
          }
        />
      </DialogContent>
      <DialogActions>
        <Button
          style={{ backgroundColor: "darkorange", borderColor: "darkorange" }}
          onClick={() => props.setOpen(false)}
        >
          Cancel
        </Button>
        <Button
          style={{ backgroundColor: "darkorange", borderColor: "darkorange" }}
          onClick={() => {
            executeMoleculeCreation(game, setGame, setTimeProgressArray);
            props.setOpen(false);
            saveObjectToLocalStorage(
              "hideMoleculeCreationDialog",
              hideOnNextReset
            );
          }}
        >
          Reset
        </Button>
      </DialogActions>
    </Dialog>
  );
}
